import { render, staticRenderFns } from "./PublishTrademark.vue?vue&type=template&id=e4e3294c&scoped=true"
import script from "./PublishTrademark.vue?vue&type=script&lang=js"
export * from "./PublishTrademark.vue?vue&type=script&lang=js"
import style0 from "./PublishTrademark.vue?vue&type=style&index=0&id=e4e3294c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e3294c",
  null
  
)

export default component.exports